module.exports = __webpack_public_path__ + "static/media/Sec-4_Banner_CN_Mobile.ee1979d1.png";